const TimelineSection = ({
  register,
  watch,
  locations,
  errors,
}) => {

  const validateDateYear = (value) => {
    if (!value) return true;
    const year = new Date(value).getFullYear();
    return year >= 1900 && year <= 2099 || "Invalid year";
  };

  return (
    <section>
      {/* <h3 className="text-sm font-semibold mb-2">Timeline</h3> */}
      <div className="grid md:grid-cols-4 gap-4">
        <div className="flex flex-col">
            <label className="text-xs text-gray-600 mb-1">Booking Date</label>
            <input
                {...register("booking_date", { validate: validateDateYear })}
                type="date"
                min="1900-01-01"
                max="2099-12-31"
                className="border rounded p-2 text-sm w-full"
            />
            {errors.booking_date && (
                <p className="text-red-500 text-sm mt-1">{errors.booking_date[0]}</p>
            )}
        </div>
        <div className="flex flex-col">
            <label className="text-xs text-gray-600 mb-1">Booking Time</label>
            <input
                {...register("booking_time")}
                type="time"
                min="00:00"
                max="23:59"
                className="border rounded p-2 text-sm w-full"
            />
            {errors.booking_time && (
                <p className="text-red-500 text-sm mt-1">{errors.booking_time[0]}</p>
            )}
        </div>
        <div className="flex flex-col">
            <label className="text-xs text-gray-600 mb-1">Placement Pickup Date</label>
            <input
                {...register("placement_pickup_date", { validate: validateDateYear })}
                type="date"
                min="1900-01-01"
                max="2099-12-31"
                className="border rounded p-2 text-sm w-full"
            />
            {errors.placement_pickup_date && (
                <p className="text-red-500 text-sm mt-1">{errors.placement_pickup_date[0]}</p>
            )}
        </div>
        <div className="flex flex-col">
            <label className="text-xs text-gray-600 mb-1">Placement Pickup Time</label>
            <input
                {...register("placement_pickup_time")}
                type="time"
                min="00:00"
                max="23:59"
                className="border rounded p-2 text-sm w-full"
            />
            {errors.placement_pickup_time && (
                <p className="text-red-500 text-sm mt-1">{errors.placement_pickup_time[0]}</p>
            )}
        </div>
        <div className="flex flex-col">
            <label className="text-xs text-gray-600 mb-1">Excepted Pickup Date</label>
            <input
                {...register("expected_pickup_date", { validate: validateDateYear })}
                type="date"
                min="1900-01-01"
                max="2099-12-31"
                className="border rounded p-2 text-sm w-full"
            />
            {errors.expected_pickup_date && (
                <p className="text-red-500 text-sm mt-1">{errors.expected_pickup_date[0]}</p>
            )}
        </div>
        <div className="flex flex-col">
            <label className="text-xs text-gray-600 mb-1">Excepted Pickup Time</label>
            <input
                {...register("expected_pickup_time")}
                type="time"
                min="00:00"
                max="23:59"
                className="border rounded p-2 text-sm w-full"
            />
            {errors.expected_pickup_time && (
                <p className="text-red-500 text-sm mt-1">{errors.expected_pickup_time[0]}</p>
            )}
        </div>
        <div className="flex flex-col">
            <label className="text-xs text-gray-600 mb-1">Excepted Delivery Date</label>
            <input
                {...register("expected_delivery_date", { validate: validateDateYear })}
                type="date"
                min="1900-01-01"
                max="2099-12-31"
                className="border rounded p-2 text-sm w-full"
            />
            {errors.expected_delivery_date && (
                <p className="text-red-500 text-sm mt-1">{errors.expected_delivery_date[0]}</p>
            )}
        </div>
        <div className="flex flex-col">
            <label className="text-xs text-gray-600 mb-1">Excepted Delivery Time</label>
            <input
                {...register("expected_delivery_time")}
                type="time"
                min="00:00"
                max="23:59"
                className="border rounded p-2 text-sm w-full"
            />
            {errors.expected_delivery_time && (
                <p className="text-red-500 text-sm mt-1">{errors.expected_delivery_time[0]}</p>
            )}
        </div>
        <div className="flex flex-col">
            <label className="text-xs text-gray-600 mb-1">Actual Pickup IN Date</label>
            <input
                {...register("actual_in_pickup_date", { validate: validateDateYear })}
                type="date"
                min="1900-01-01"
                max="2099-12-31"
                className="border rounded p-2 text-sm w-full"
            />
            {errors.actual_in_pickup_date && (
                <p className="text-red-500 text-sm mt-1">{errors.actual_in_pickup_date[0]}</p>
            )}
        </div>
        <div className="flex flex-col">
            <label className="text-xs text-gray-600 mb-1">Actual Pickup IN Time</label>
            <input
                {...register("actual_in_pickup_time")}
                type="time"
                min="00:00"
                max="23:59"
                className="border rounded p-2 text-sm w-full"
            />
            {errors.actual_in_pickup_time && (
                <p className="text-red-500 text-sm mt-1">{errors.actual_in_pickup_time[0]}</p>
            )}
        </div>
        <div className="flex flex-col">
            <label className="text-xs text-gray-600 mb-1">Actual Pickup Out Date</label>
            <input
                {...register("actual_out_pickup_date", { validate: validateDateYear })}
                type="date"
                min="1900-01-01"
                max="2099-12-31"
                className="border rounded p-2 text-sm w-full"
            />
            {errors.actual_out_pickup_date && (
                <p className="text-red-500 text-sm mt-1">{errors.actual_out_pickup_date[0]}</p>
            )}
        </div>
        <div className="flex flex-col">
            <label className="text-xs text-gray-600 mb-1">Actual Pickup Out Time</label>
            <input
                {...register("actual_out_pickup_time")}
                type="time"
                min="00:00"
                max="23:59"
                className="border rounded p-2 text-sm w-full"
            />
            {errors.actual_out_pickup_time && (
                <p className="text-red-500 text-sm mt-1">{errors.actual_out_pickup_time[0]}</p>
            )}
        </div>
        <div className="flex flex-col">
            <label className="text-xs text-gray-600 mb-1">Actual Delivery IN Date</label>
            <input
                {...register("actual_in_delivery_date", { validate: validateDateYear })}
                type="date"
                min="1900-01-01"
                max="2099-12-31"
                className="border rounded p-2 text-sm w-full"
            />
            {errors.actual_in_delivery_date && (
                <p className="text-red-500 text-sm mt-1">{errors.actual_in_delivery_date[0]}</p>
            )}
        </div>
        <div className="flex flex-col">
            <label className="text-xs text-gray-600 mb-1">Actual Delivery IN Time</label>
            <input
                {...register("actual_in_delivery_time")}
                type="time"
                min="00:00"
                max="23:59"
                className="border rounded p-2 text-sm w-full"
            />
            {errors.actual_in_delivery_time && (
                <p className="text-red-500 text-sm mt-1">{errors.actual_in_delivery_time[0]}</p>
            )}
        </div>
        <div className="flex flex-col">
            <label className="text-xs text-gray-600 mb-1">Actual Delivery Out Date</label>
            <input
                {...register("actual_out_delivery_date", { validate: validateDateYear })}
                type="date"
                min="1900-01-01"
                max="2099-12-31"
                className="border rounded p-2 text-sm w-full"
            />
            {errors.actual_out_delivery_date && (
                <p className="text-red-500 text-sm mt-1">{errors.actual_out_delivery_date[0]}</p>
            )}
        </div>
        <div className="flex flex-col">
            <label className="text-xs text-gray-600 mb-1">Actual Delivery Out Time</label>
            <input
                {...register("actual_out_delivery_time")}
                type="time"
                min="00:00"
                max="23:59"
                className="border rounded p-2 text-sm w-full"
            />
            {errors.actual_out_delivery_time && (
                <p className="text-red-500 text-sm mt-1">{errors.actual_out_delivery_time[0]}</p>
            )}
        </div>
      </div>
    </section>
  );
};

export default TimelineSection;
